

import { auctions } from "../../data/auctions";
import AuctionCard from "../../components/AuctionCard/AuctionCard";
import Slider from 'react-slick'
import ButtonType1 from "../../components/ButtonType1/ButtonType1";

const AuctionList = () => {

    const settings = {
        dots: false,
        className: "center",
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
          {
            breakpoint: 1450,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
            {
              breakpoint: 1114,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            },
        ]
    };

    return (
        <div className="flex flex-col">
            <div className="flex justify-between items-center mb-5">
                <h2 className="font-[500] text-center text-2xl md:text-3xl lg:text-4xl tracking-wide">
                    Hot Auctions
                </h2>
                <ButtonType1 title = 'View All' />
            </div>
            <Slider {...settings}>
                {auctions.map((item, index) => {
                if(index < 4){
                    return (
                        <AuctionCard auction={item} key = {index} className = "mx-3" />
                    )
                }
                else{
                    return null;
                }
                })}
            </Slider>
        </div>
    );
}

export default AuctionList;